import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeToast } from './toastSlice';
import { retryIntersections } from '../trafficInfra/trafficInfraSlice';
import { retryDeviceState } from '../deviceState/deviceStateSlice';
import { retryTunnelState } from '../tunnelState/tunnelStateSlice';
import classes from './Toast.module.css';
import signalRed from '../../assets/signal_veh_red.svg';
import signalYellow from '../../assets/signal_veh_yellow.svg';
import signalGreen from '../../assets/signal_veh_green.svg';

export const Toast = ({ id, message, type = 'error', retryAction, autoDismiss = true, duration }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (autoDismiss) {
            // Use provided duration, or default: 120 seconds for errors, 10 seconds for other types
            const dismissTime = duration || (type === 'error' ? 120000 : 10000);
            const timer = setTimeout(() => {
                dispatch(removeToast(id));
            }, dismissTime);

            return () => clearTimeout(timer);
        }
    }, [id, autoDismiss, type, dispatch, duration]);

    const handleRetry = () => {
        // Map retry action string to actual Redux action
        if (retryAction === 'RETRY_INTERSECTIONS') {
            dispatch(retryIntersections());
        } else if (retryAction === 'RETRY_DEVICE_STATE') {
            dispatch(retryDeviceState());
        } else if (retryAction === 'RETRY_TUNNEL_STATE') {
            dispatch(retryTunnelState());
        }
        dispatch(removeToast(id));
    };

    const handleDismiss = () => {
        dispatch(removeToast(id));
    };

    // Traffic light themed icons
    const getIcon = () => {
        switch (type) {
            case 'error':
                return signalRed;
            case 'warning':
                return signalYellow;
            case 'info':
                return signalGreen;
            default:
                return signalYellow;
        }
    };

    return (
        <div className={`${classes.Toast} ${classes[type]}`}>
            <div className={classes.Content}>
                <img src={getIcon()} alt={`${type} icon`} className={classes.Icon} />
                <span className={classes.Message}>{message}</span>
            </div>
            <div className={classes.Actions}>
                {retryAction && (
                    <button onClick={handleRetry} className={classes.RetryButton}>
                        Retry
                    </button>
                )}
                <button onClick={handleDismiss} className={classes.DismissButton} aria-label="Dismiss">
                    ×
                </button>
            </div>
        </div>
    );
};
